import { configureStore } from "@reduxjs/toolkit";
import loginReducer from "./slices/loginSlice";
import searchReducer from "./slices/searchSlice";
import notificationReducer from "./slices/desktopNotificationSlice";
import desktopAppsReducer from "./slices/desktopAppsSlice";
import headersReducer from './slices/headers.slice';
import serviceNowReducer from './slices/serviceNowSlice';

const appStore = configureStore({
    reducer: {
        login: loginReducer,
        search: searchReducer,
        notifications: notificationReducer,
        desktopApps: desktopAppsReducer,
        headers: headersReducer,
        serviceNowDetails: serviceNowReducer
    }
});

export default appStore;

export type RootState = ReturnType<typeof appStore.getState>;
export type AppDispatch = typeof appStore.dispatch;